import React, { useState } from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../../../components/NovoSistema/DoubleInput';
import InputDate from '../../../../../../../../components/NovoSistema/InputDate';
import InputCheckBox from '../../../../../../../../components/NovoSistema/InputCheckBox';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import InputText from '../../../../../../../../components/NovoSistema/InputText';

export default function GerencialDeEstoqueFilter() {
  const [option, setOption] = useState('Filtro');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Filtro"
          border="#DFB007"
          active={option === 'Filtro' ? true : false}
          yourFunction={() => setOption('Filtro')}
        />
      </HeaderButtons>
      {option === 'Filtro' && (
        <ContainerSection>
          <WrapperInputsNewSystem>
            <InputDate title="Data" id="Data" widthPercentage="20%" />
            <DoubleInput title="Produto" id="Produto" widthPercentage="70%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Grupo Inicial" id="GrupoInicial" widthPercentage="45%" />
            <DoubleInput title="Grupo Final" id="GrupoFinal" widthPercentage="45%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Marca Inicial" id="MarcaInicial" widthPercentage="45%" />
            <DoubleInput title="Marca Final" id="MarcaFinal" widthPercentage="45%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Quebra por"
              id="QuebraPor"
              optionsArray={['Produto', 'Grupo de Produto', 'Marca']}
              widthPercentage="30%"
            />
            <SelectAndOptions
              title="Situação"
              id="Situacao"
              optionsArray={['', 'Ativo', 'Inativo']}
              widthPercentage="30%"
            />
            <InputText title="Dias Parado" id="DiasParado" widthPercentage="30%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputCheckBox title="Exibir somente estoque abaixo do mínimo" id="ExibirSomenteEstoqueAbaixoDoMinimo" />
            <InputCheckBox title="Exibir somente estoque abaixo do máximo" id="ExibirSomenteEstoqueAbaixoDoMaximo" />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="normal">Limpar</button>
          </ButtonsGeneric>
        </ContainerSection>
      )}
    </div>
  );
}
